import { SagaMiddleware } from 'redux-saga';
import saga from './sagas';

export function configureApi(sagaMiddleware: SagaMiddleware) {
  sagaMiddleware.run(saga);
}
